import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'

const Schema = yup.object().shape({
  currency: yup.string(),
  address: yup
    .string()
    .required('This field is required')
    .min(1, 'Must have at least 1 characters')
    .max(50, 'Must have up to 50 characters')
    .matches(/^[a-zA-Z0-9!@#$%^&*\s()_+\-=[\]{};':"\\|,.<>/?]*$/, 'Latin letters, numbers and special symbols only'),
  suffix: yup
    .string()
    .required('This field is required')
    .min(1, 'Must have at least 1 characters')
    .max(15, 'Must have up to 15 characters')
    .matches(/^[a-zA-Z0-9!@#$%^&*\s()_+\-=[\]{};':"\\|,.<>/?]*$/, 'Latin letters, numbers and special symbols only'),
})

export const resolverCrypto = yupResolver(Schema)
